import { Container } from 'pixi.js';
import { MainSignals, TickCallData } from '../../../../settings/constants';
import { SineInOut } from '../../../../helpers/Easing';
import { SceneSettings, SCENE_FADE_TIME } from '../../../../settings/positions';
import { swapAtmo, swapMusic } from '../../../../helpers/SoundManager';

export default class SceneBase extends Container {
  signals: MainSignals;
  sceneSettings: SceneSettings;
  musicId: number | null;
  atmoId: number | null;
  hideScale: boolean;

  show = 0;
  hideStart = 0;
  hideEnd = 0;
  hideLength = 0;

  isActive = false;

  constructor(
    signals: MainSignals,
    sceneSettings: SceneSettings,
    musicId: number | null,
    atmoId: number | null,
    hideScale = true,
  ) {
    super();

    // vars
    this.signals = signals;
    this.sceneSettings = sceneSettings;
    this.musicId = musicId;
    this.atmoId = atmoId;
    this.hideScale = hideScale;

    // props
    this.visible = false;

    // setup
    this.parseSettings();

    // listeners
    signals.tickCall.add(this.tickCall, this);
  }

  // --------------------------------------------------------------
  // Settings
  // --------------------------------------------------------------

  parseSettings(): void {
    this.show = this.sceneSettings.start;
    this.hideStart = this.show + this.sceneSettings.length;
    this.hideLength = SCENE_FADE_TIME;
    this.hideEnd = this.hideStart + this.hideLength;
  }

  // --------------------------------------------------------------
  // Tick
  // --------------------------------------------------------------

  tickCall(data: TickCallData): void {
    const { scroll } = data;
    if (scroll >= this.show && scroll <= this.hideEnd) {
      this.visible = true;
      const progress = Math.min(1, Math.max(0, (scroll - this.hideStart) / this.hideLength));
      const easedProgress = SineInOut(progress);
      this.alpha = 1 - easedProgress;
      if (this.hideScale) {
        this.scale.set(1 + easedProgress * 0.2);
      }
    } else {
      this.visible = false;
    }

    this.setActive(scroll >= this.show && scroll <= this.hideStart);
  }

  // --------------------------------------------------------------
  // Active switch
  // --------------------------------------------------------------

  setActive(value: boolean): void {
    if (this.isActive !== value) {
      this.isActive = value;
      if (this.isActive) {
        this.activeSwitch();
      }
    }
  }

  activeSwitch(): void {
    swapMusic(this.musicId);
    swapAtmo(this.atmoId);
  }
}
